import * as React from 'react'
import type { SVGProps } from 'react'
const ChevronUp = (props: SVGProps<SVGSVGElement>) => (
<svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.55807 7.05806C9.80215 6.81398 10.1978 6.81398 10.4419 7.05806L16.2752 12.8914C16.5193 13.1355 16.5193 13.5312 16.2752 13.7752C16.0312 14.0193 15.6355 14.0193 15.3914 13.7752L9.99999 8.38391L4.6086 13.7752C4.36452 14.0193 3.96879 14.0193 3.72471 13.7752C3.48064 13.5312 3.48064 13.1355 3.72471 12.8914L9.55807 7.05806Z" fill="#252525"/>
</svg>

)
export default ChevronUp